import { motion } from "framer-motion";

export default function BlogFilters({ topics, active, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-3 w-full sm:grid-cols-3 lg:grid-cols-5">
      {topics.map((t) => (
        <motion.button
          key={t}
          type="button"
          whileHover={{ y: -1 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onChange?.(t)}
          className={`w-full justify-center rounded-full px-5 py-3 text-sm font-medium ring-1 transition ${
            active === t
              ? "bg-emerald-600 text-white ring-emerald-600"
              : "bg-white text-emerald-800 ring-emerald-600/30 hover:bg-emerald-50"
          }`}
        >
          {t}
        </motion.button>
      ))}
    </div>
  );
}


